import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CrossBorderWithdrawalInfo from './CrossBorderWithdrawalInfo';
import useFetchCrossBorderTransactions from '@/hooks/useApi/useFetchCrossBorderTransactions';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type DataProps = {
  transactionId: string;
  activeModule: string;
  hasNewTransactionButton: boolean;
  clientAccountId: string;
};

type CrossBorderWithdrawalProps = {
  transactionId: string;
  notes: string;
};

type FC = FunctionComponent<CrossBorderWithdrawalProps>;

const EftWithdrawTransactionContainer: FC = ({ transactionId, notes }: CrossBorderWithdrawalProps) => {
  const { state } = useLocation<DataProps>();

  const { userSettings } = useUserSettingsProvider();
  const { transactions, fetchTransactions } = useFetchCrossBorderTransactions();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.GlobalSendRecentTransaction>();

  useEffect(() => {
    fetchTransactions({
      ClientAccountID: state.clientAccountId,
      TransactionID: transactionId,
      Timezone: userSettings.timezone,
    });
  }, [currentTransactionId, transactionId]);

  useEffect(() => {
    if (transactions) {
      setTransaction(transactions[0]);
    }
  }, [transactions]);

  if (currentTransactionId !== transactionId) {
    setCurrentTransactionId(transactionId);
  }

  return <div>{transaction && <CrossBorderWithdrawalInfo transaction={transaction} notes={notes} />}</div>;
};

export default EftWithdrawTransactionContainer;
